var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 90,
    viewBox: "0 0 193 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.655 4.14619C167.821 1.01639 165.441 0 161.823 0H30.699C27.081 0 27.9184 0.290809 21.4152 4.14619L1.49609 14.7507C1.49609 17.0397 2.93417 19.6944 6.55211 19.6944H186.903C190.521 19.6944 191.64 16.8209 191.64 14.529L173.655 4.14619Z",
    fill: "#2DACCB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193 85.4616C193 87.9596 190.072 89.9863 186.462 89.9863H6.53776C2.92837 89.9863 0 87.9596 0 85.4616V19.511C0 17.013 2.92837 14.9863 6.53776 14.9863H186.462C190.072 14.9863 193 17.013 193 19.511V85.4616Z",
    fill: "#50DCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBox);
export default __webpack_public_path__ + "static/media/BlueBox.f631ec78d5c811331e61dabb48537a65.svg";
export { ForwardRef as ReactComponent };